import { Chakra, ActionButton } from "@airhelp/react-ui-components";
import { useLanguage } from "contexts/LocalizationContext";
import LanguageSwitcherModal from "components/LanguageSwitcher/LanguageSwitcherModal/LanguageSwitcherModal";
import { trackEvents } from "utils/trackingUtils";
import generateFlagKey from "./utils/generateFlagKey";

const { useBreakpointValue } = Chakra;

const FlagBox = ({
  /* eslint-disable react/prop-types */
  // TODO after modalContext TS migration
  openModal,
  // TODO after trackingUtils TS migration
  trackingEvents,
}) => {
  const currentLanguage = useLanguage();
  const modalSize = useBreakpointValue({ base: "full", lg: "xl" });

  const handleClick = () => {
    openModal(<LanguageSwitcherModal />, modalSize);
    trackEvents(trackingEvents);
  };

  return <ActionButton flagKey={generateFlagKey(currentLanguage)} handleOnClick={handleClick} />;
};

export default FlagBox;
